import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IAllTemplatePoliciesResponse, ICreateUpdateTemplatePolicyRequest, TemplatePolicyType } from "../models/TemplatePolicy";

export default function useTemplatePolicies() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const templatePolicies = useQuery({
    queryKey: ["templatePolicies"],
    queryFn: () => get<IAllTemplatePoliciesResponse>("/TemplatePolicy"),
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  const create = useMutation(
    (request: ICreateUpdateTemplatePolicyRequest) => post("/TemplatePolicy", request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["templatePolicies"]);
      },
    }
  );

  const update = useMutation(
    ({ id, request }: { id: string; request: ICreateUpdateTemplatePolicyRequest }) => 
      put(`/TemplatePolicy/${id}`, request),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["templatePolicies"]);
      },
    }
  );

  const remove = useMutation(
    (templatePolicyId: string) => del(`/TemplatePolicy/${templatePolicyId}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["templatePolicies"]);
      },
    }
  );

  const getTemplatePolicyByType = (type: TemplatePolicyType) => {
    return templatePolicies.data?.data?.find(policy => policy.type === type);
  };

  return {
    templatePolicies,
    create,
    update,
    remove,
    getTemplatePolicyByType,
  };
} 